import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ReferralPage() {
  const location = useLocation(); 
  const API_BASE = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const checkAndRedirect = async () => {
      try {
        await fetch(`${API_BASE}/api/domains/check-all`, {
          method: 'POST',
        });
  
        const params = new URLSearchParams(location.search);
        const path = params.get('path') || location.pathname;
  
        params.delete('path');
        const query = params.toString();
  
        const redirectUrl = `${API_BASE}/api/redirect${path}${query ? '?' + query : ''}`;
        window.location.href = redirectUrl;
      } catch (err) {
        console.error('❌ Помилка під час перевірки доменів:', err);
      }
    };
  
    checkAndRedirect();
  }, [location]);

  return <div>Redirecting...</div>;
}
